export const API_CONFIG = {
  baseUrl: process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000",
  endpoints: {
    auth: {
      signin: "/auth/signin/",
      signup: "/auth/signup/",
      forgotPassword: "/auth/forgot-password/",
      resetPassword: "/auth/reset-password/",
    },
    teams: {
      list: "/api/teams/",
      invite: (teamId: string) => `/api/teams/${teamId}/invite/`,
      members: (teamId: string) => `/api/teams/${teamId}/members/`,
      pendingInvites: (teamId: string) => 
        `/api/teams/${teamId}/pending_invitations/`,
    },
    invitations: {
      verify: (token: string) => `/api/invitations/${token}/verify/`,
      accept: (token: string) => `/api/invitations/${token}/accept/`,
    }
  }
}; 